<script>
import RawData from "@/components/widgets/raw-data.vue";
import groupBy from "lodash/groupBy";
export default {
    components: {
        RawData,
    },
    props: {
        loading: Boolean,
        tabOptions: {
            type: Array,
            required: true
        },
        targetList: {
            type: Array,
            default: () => []
        },
        weightSPC: {
            type: Number,
            default: 90
        },
        weightMandatorySupportFunctions: {
            type: Number,
            default: 10
        },
        tabType: {
            type: String,
            default: "SUBMITTED"
        },
        filter: {
            type: String,
            default: ''
        },
        selectedDu: {
            type: [Object, null],
            default: null
        }
    },
    data() {
        return {

        }
    },
    methods: {
        filteredKpi(types) {
            let arr = this.targetList;
            let data = [];
            if (types && types.length && this.targetList.length) {
                types.map(type => {
                    data = data.concat(arr.filter((item) => {
                        return item.category.toLowerCase().includes(type.toLowerCase());
                    }));
                });
            } else {
                data = arr;
            }
            if (!data.length) return [];
            data = data.filter((item) => {
                if (this.tabType == 'ALL') {
                    return (
                        item.searchKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase())
                    );
                } else {
                    return (
                        item.searchKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase()) &&
                        item.accomplishmentStatus == this.tabType
                    );
                }
            });
            return this.groupedTargets(data);
        },

        groupedTargets(props) {
            var array = [];
            var x = groupBy(props, "indicatorItemId");
            for (const xKey in x) {
                {
                    array.push({
                        indicatorItemId: xKey,
                        indicatorItemName: x[xKey][0].indicatorItemName,
                        details: x[xKey]
                    });
                }
            }
            return array;
        },
        typeWeight(arrType) {
            if (arrType.length > 1) return this.weightSPC;
            else if (arrType.includes("Mandatory Support Function"))
                return this.weightMandatorySupportFunctions;
        },
        calcAve(scoreQuality, scoreEfficiency, scoreTimeliness) {
            let sum =
                parseFloat(scoreQuality) +
                parseFloat(scoreEfficiency) +
                parseFloat(scoreTimeliness);

            var count = 0;
            if (parseFloat(scoreQuality) != 0) count++;
            if (parseFloat(scoreEfficiency) != 0) count++;
            if (parseFloat(scoreTimeliness) != 0) count++;

            let ave = sum / count;
            return isNaN(ave) ? 0 : ave;
        },

        validatorFeedback(feedback) {
            if (feedback == "") return "";
            if (feedback == "LSD") return "Lacking supporting documents (LSD)";
            if (feedback == "NTI") return "No Target Indicated (NTI)";
            if (feedback == "NAI") return "No Accomplishment Indicated (NAI)";
            if (feedback == "AIT")
                return "Accomplishment Inconsistent with Target (AIT)";
            if (feedback == "ES") return "Evidence Sufficient (ES)";
            if (feedback == "EIS") return "Evidence Insufficient (EIS)";
            if (feedback == "LSE") return "Label Submitted Evidence (LSE)";
            if (feedback == "NEA") return "No Evidence Attached (NEA)";
            if (feedback == "NAVI") return "No Absolute Value Indicated (NAVI)";
            if (feedback == "KNF") return "KPI not found in approved OPCR (KNF)";
            if (feedback == "KFD")
                return "KPI Found in approved OPCR but Deleted (KFD)";
            if (feedback == "FPD") return "For PMTs Deliberation (FPD)";
        },

        getInitialDate(y) {
            return this.formatDateShortWTime(new Date(
                y?.jsonRemarks?.filter(x => x.remarks === 'Accomplishment Posted')
                    .sort((a, b) => new Date(a.remarksDate) - new Date(b.remarksDate))[0]?.remarksDate
                || y?.datePosted)
            )
        },
    }
}
</script>
<template>
    <div>
        <div class="position-relative">
            <table class="table project-list-table table-centered table-borderless mb-2">
                <thead>
                    <tr style="background-color: #262b3c !important">
                        <th style="width:60px !important" rowspan="2"></th>
                        <th class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app"
                            rowspan="2">
                            Description
                        </th>
                        <th style="width: 130px !important"
                            class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app text-center"
                            rowspan="2">
                            Annual Target
                        </th>
                        <th style="width: 130px !important" rowspan="2"
                            class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app text-center font-size-12">
                            Actual Accomplishment
                        </th>
                        <th style="width: 240px !important" colspan="4"
                            class="text-center border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app p-0">
                            <div class="text-center">
                                <div class="border-dark-bottom pb-2">
                                    Rating
                                </div>
                                <div class="d-flex">
                                    <div class="w-25 border-dark-right p-1">
                                        Q
                                    </div>
                                    <div class="w-25 border-dark-right py-1">
                                        E
                                    </div>
                                    <div class="w-25 border-dark-right py-1">
                                        T
                                    </div>
                                    <div class="w-25 py-1">Ave</div>
                                </div>
                            </div>
                        </th>
                        <th style="width: 280px !important" rowspan="2"
                            class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app text-center">
                            Remarks
                        </th>
                        <th style="width: 200px !important" rowspan="2"
                            class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app text-center">
                            Date Submitted
                        </th>
                        <th style="width: 120px !important" rowspan="2"
                            class="align-middle border-2 border-top-0 border-start-0 border-bottom-0 border-dark-app text-center">
                            Status
                        </th>
                        <th style="width: 80px !important" class="text-center align-middle" rowspan="2">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading" style="background-color: transparent; box-shadow: none">
                        <td colspan="100%">
                            <div class="p-3 d-flex align-items-center" v-if="loading">
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div class="spinner-chase w-20px h-20px">
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <h5 class="mb-0">Loading...</h5>
                            </div>
                        </td>
                    </tr>
                    <template v-else-if="!targetList.length">
                        <tr>
                            <td colspan="100%" class="text-center">
                                <h5 class="m-0">No data available</h5>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <template v-for="(tab, index) in tabOptions">
                            <template v-if="filteredKpi(tab.types).length">
                                <tr :key="`class-${index}`" style="background-color: transparent; box-shadow: none">
                                    <td colspan="100%" class="py-0">
                                        <div class="d-flex align-items-center">
                                            <div :style="{ width: '10px', height: '10px', borderRadius: '50%' }"
                                                class="bg-success ms-2 me-3">
                                            </div>
                                            <b class="font-size-14 text-white">
                                                {{ tab.types.join('/') }} ({{ typeWeight(tab.types) }}%)
                                            </b>
                                        </div>
                                    </td>
                                </tr>
                                <template v-for="(kpi, kpiIndex) in filteredKpi(tab.types)">
                                    <tr :key="`indItem-${index}-${kpiIndex}`"
                                        style="background-color: transparent; box-shadow: none">
                                        <td colspan="100%" class="p-0-20p">
                                            <div class="d-flex align-items-center mb-2 ms-3">
                                                <div style="width: 5px; height: 5px"
                                                    class="bg-warning bg-gradient ms-2 me-2"></div>
                                                <b> KPI: {{ kpi.indicatorItemName }} </b>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-for="(y, targetIndex) in kpi.details">
                                        <tr :key="`target-${index}-${kpiIndex}-${targetIndex}`"
                                            style="background-color: transparent; box-shadow: none">
                                            <td></td>
                                            <td class="bg-table-tr ">
                                                <div class="position-relative">
                                                    <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                                                    <span class="text-white">
                                                        {{ y.targetDescription }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span class="text-white">
                                                    {{ y.annualTarget }}
                                                    <span v-if="y.annualTarget && y.isPercentage">%</span>
                                                </span>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span class="text-white">
                                                    {{ y.actualAccomplishment }}<span
                                                        v-if="y.actualAccomplishment && y.isPercentage">%</span>
                                                </span>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span v-if="!y.isNotApplicable" class="text-white">{{
                                                    y.evaluationScoreQuality
                                                    }}</span>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span v-if="!y.isNotApplicable" class="text-white">{{
                                                    y.evaluationScoreEfficiency
                                                    }}</span>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span v-if="!y.isNotApplicable" class="text-white">{{
                                                    y.evaluationScoreTimeliness
                                                    }}</span>
                                            </td>
                                            <td class="bg-table-tr text-center">
                                                <span :class="{ 'text-white': !y.isNotApplicable }">{{
                                                    !y.isNotApplicable
                                                        ? calcAve(
                                                            y.evaluationScoreQuality,
                                                            y.evaluationScoreEfficiency,
                                                            y.evaluationScoreTimeliness
                                                        )
                                                        : "N/A"
                                                }}</span>
                                            </td>
                                            <td class="bg-table-tr">
                                                <span class="text-white">{{ validatorFeedback(y.planningFeedback)
                                                    }}</span>
                                                <div>
                                                    {{ y.planningRemarks }}
                                                </div>
                                            </td>
                                            <td style="width: 200px !important" class="bg-table-tr text-center">
                                                <span class="text-white">{{
                                                    getInitialDate(y)
                                                    }}</span>
                                            </td>
                                            <td style="width: 120px !important" class="bg-table-tr text-center">
                                                <b :class="{
                                                    'text-success font-size-12':
                                                        y.accomplishmentStatus ==
                                                        'COMPLETED',
                                                    'text-warning font-size-12':
                                                        y.accomplishmentStatus ==
                                                        'SUBMITTED'
                                                }">{{ y.accomplishmentStatus }}</b>
                                            </td>
                                            <td style="width: 80px !important" class="bg-table-tr text-end">
                                                <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`submitted-popover-${tabType}-DU${selectedDu.deliveryUnitId}-KPI${kpi.indicatorItemId}-Target${y.id}`
                                                    " tabindex="0"></i>
                                                <b-popover :target="`submitted-popover-${tabType}-DU${selectedDu.deliveryUnitId}-KPI${kpi.indicatorItemId}-Target${y.id}`
                                                    " triggers="click blur" placement="leftbottom" variant="secondary"
                                                    custom-class="p-0">
                                                    <b-list-group class="w-100 fit">
                                                        <b-list-group-item button action
                                                            class="d-flex align-items-center text-success"
                                                            @click="$emit('rateTarget', y)"><i
                                                                class="bx bx-check font-size-18 me-1"></i>Rate
                                                            Target</b-list-group-item>
                                                        <b-list-group-item button action
                                                            class="d-flex align-items-center text-warning" @click="
                                                                $emit('returnTarget', {
                                                                    row: y,
                                                                    type: 'return submitted'
                                                                })
                                                                "><i class="bx bx-undo font-size-18 me-1"></i>Return to
                                                            Secretariat</b-list-group-item>
                                                        <b-list-group-item button action
                                                            class="d-flex align-items-center text-purple"
                                                            @click="$emit('getAttachments', y)"><i
                                                                class="bx bx-paperclip font-size-18 me-1"></i>View
                                                            Attachments</b-list-group-item>
                                                        <b-list-group-item button action
                                                            class="d-flex align-items-center text-info"
                                                            @click="$emit('viewReturnRamarks', { pmeLogs: y.jsonRemarks, pmtLogs: y.targetLogs })">
                                                            <i class="bx bx-time-five font-size-18 me-1"></i>
                                                            View Logs
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </b-popover>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>